import * as signalR from "@microsoft/signalr";
import { connect } from "http2";

// export interface WorkScheduleData {
//     [key: string]: string;
// }
let id = "default ID";

export default function WorkScheduleHub(props: {
  workScheduleId: string;
  setWorkScheduleData?: Function;
}) {
  const { workScheduleId, setWorkScheduleData } = props;

  let connection = new signalR.HubConnectionBuilder()
    .withUrl(`${process.env.REACT_APP_BASE_URL}workScheduleHub`)
    .build();
  connection
    .start()
    .then(() => {
      console.log("started WorkScheduleHub:", workScheduleId);
      id = workScheduleId;
      connection.invoke("SubscribeToWorkScheduleData", workScheduleId);
    })
    .catch((err: any) => {
      return console.error(err.toString());
    });

  connection.on("ReceiveSensorData", (data: string) => {
    setWorkScheduleData && setWorkScheduleData(data);
  });

  return () => {
    connection.stop();
  }
}

export function SendDataToWorkScheduleHub(props: { data: string }) {
  const { data } = props;

  let connection = new signalR.HubConnectionBuilder()
    .withUrl(`${process.env.REACT_APP_BASE_URL}workScheduleHub`)
    .build();

  connection
    .start()
    .then(() => {
      connection.invoke("SendWorkScheduleData", id, data).catch((err: any) => {
        console.error("Error sending data:", err);
        console.error("Error details:", err.toString());
      })
      .finally(()=>{
        connection.stop();
      });
    })
    .catch((err: any) => {
      console.error("Error starting connection:", err);
      console.error("Error details:", err.toString());
      connection.stop();
    });
}
